<template>
  <page-edicion title="Crear unidad de negocio">
    <page-header title="Crear unidad de negocio" back-to="/unidadesNegocio" />
    <formulario :unidad-negocio="unidadNegocio" :paises-id="paisesId" @submit="insertar" />
  </page-edicion>
</template>

<script>
import Formulario from "./Formulario.vue";
import * as unidadesNegocioApi from "@/services/unidadesNegocio.js";

export default {
  components: { Formulario },
  data() {
    return {
      unidadNegocio: unidadesNegocioApi.crear(),
      paisesId: [],
    };
  },
  methods: {
    insertar(paisesSeleccionados) {
      var unidadNegocio = {
        unidadNegocio: this.unidadNegocio,
        paises: paisesSeleccionados,
      };
      unidadesNegocioApi.insertar(unidadNegocio).then(() => {
        this.$router.push({ path: "/unidadesNegocio" });
      });
    },
  },
};
</script>
